import { VuexModule, Module, Action } from 'vuex-module-decorators';
import { TechAppUserState } from '@/store/types';
import { TechAppUser, techAppUserRepository } from '@/store/modules';
import { normalizeError } from '@/utility';

@Module
export class TechAppUserModule extends VuexModule implements TechAppUserState {
  @Action
  async all(payload: { params?: any } = {}) {
    TechAppUser.commit(state => {
      state.fetching = true;
      state.error.length = 0;
    });

    try {
      const { status, data } = await techAppUserRepository.all({ params: payload.params });

      if (status < 200 || status >= 300) {
        console.error('Invalid 2XX response status');
        throw `Invalid response code: ${status}`;
      }

      if (!data || !data.results || !Array.isArray(data.results)) {
        console.error('Invalid data format');
        throw 'Invalid response payload.';
      }

      // The endpoint now returns paginated results
      TechAppUser.create({
        data: data.results
      });

      TechAppUser.commit(state => {
        state.fetching = false;
        state.total = data.total;
        state.orderedItems = data.results; // Store the ordered results
      });

    } catch (err) {
      console.error(err);
      const e = (normalizeError(err) || err);

      TechAppUser.commit(state => {
        state.fetching = false;
        state.total = 0;
        state.orderedItems = [];
        state.error.push(e);
      });
    }
  }
}
